module.exports = __webpack_public_path__ + "img/footer.925afa2f.925afa2f.png";